<template>
  <div :class="$isFlag ? 'contentlistH5' : 'contentlistWeb'">
    <common-navbar v-if="$isFlag" :is-home-bar="true" />
    <img
      v-if="$isFlag"
      src="~assets/images/accountCenter/bgcenter.png"
      alt=""
      style="width: 100%"
    >
    <div class="entrance">
      <p v-for="(item, index) in list" :key="index" @click="typeClick(index)">
        <img
          v-if="$isFlag"
          :src="require('@/assets/images/accountCenter/' + item.url + '.png')"
          alt=""
          srcset=""
        >
        <img
          v-else
          :src="
            require('@/assets/images/accountCenter/' + item.webUrl + '.png')
          "
          alt=""
          srcset=""
        >
      </p>
    </div>
  </div>
</template>

<script>
import commonNavbar from '@/views/accountCenter/common/commonNavbar'

export default {
  name: 'Entrance',
  components: { commonNavbar },
  data() {
    return {
      list: [
        { name: '密码找回', url: 'mmzh', webUrl: 'mmzh_w' },
        { name: '修改绑定手机号', url: 'xgsjh', webUrl: 'xgsjh_w' },
        { name: '申诉相关', url: 'suxg', webUrl: 'suxg_w' },
        { name: '保护性冻结/解冻', url: 'bhdj', webUrl: 'bhdj_w' },
        { name: '客服专区', url: 'kfzq', webUrl: 'kfzq_w' }
      ]
    }
  },
  created() {},
  mounted() {},
  methods: {
    typeClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/accountCenter/accountSelf/findPassWord')
          this.$ssd.track('leiting_accountmanage_retrievePassword')
          break
        case 1:
          this.$ssd.track('leiting_accountcenter_changephonenumber')
          // this.$router.push('/accountCenter/accountList/phoneAuth')
          this.$router.push('/accountCenter/accountList/phoneManage')
          break
        case 2:
          this.$ssd.track('leiting_accountcenter_accountAppeal')
          this.$router.push('/accountCenter/accountSelf/accountAppeal')
          break
        case 3:
          this.$ssd.track('leiting_accountcenter_freeze')
          this.$router.push('/accountCenter/accountSelf/accountFreeze')
          break
        case 4:
          this.$ssd.track('leiting_accountcenter_freeze')
          window.open('https://helper.leiting.com/')
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.contentlistWeb {
  .entrance {
    font-size: 0.28rem;
    margin: 5% 0 10%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap
  }

  p {
    width: 3.2rem
    height: 5.2rem
    margin: 0 .2rem .2rem
    display: flex;
    justify-content: space-around;
    cursor pointer

    &:hover {
      transform: translate3d(0, -5px, 0);
      transition-duration: 0.5s;
      box-shadow: 0 16px 32px 0 rgba(48, 55, 66, 0.15);
    }
  }
  }

// h5
.contentlistH5 {
  position: relative;

  .entrance {
    font-size: 0.28rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    // padding: 0 0.35rem 0.4rem;
    padding: 0 0.5rem 0.4rem;
  }

  p {
    width: 45%;
    margin-top: 0.5rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    // img {
    //   width: 100%;
    // }
  }
}
</style>
